import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { take } from 'rxjs/operators';
import { QuoteEmailLandingService } from '../service/quote-email-landing.service';
import { Subscription } from 'rxjs';
import { StartUpConfigUiService, GtmDatalayerUiService } from '../../../Core/Services';

@Component({
  selector: 'app-quote-email-landing',
  templateUrl: './quote-email-landing.component.html',
  styleUrls: ['./quote-email-landing.component.css']
})
export class QuoteEmailLandingComponent implements OnInit {
  private isProcessingLandingCalled: boolean = false;
  private subscription: Subscription;

  constructor(private route: ActivatedRoute,
    private landingService: QuoteEmailLandingService,
    private router: Router,
    private startUpConfigUiService: StartUpConfigUiService,
    private gtmDatalayerUIService: GtmDatalayerUiService

  ) { }

  private performRedirection(source: string,id:string): void {
    setTimeout(() => {
      this.router.navigate(['/progress'], {
        queryParamsHandling: 'merge',
        queryParams: {
          source: source,
          id:id
        }
      });
    }, 3000);
  }
  private handleRedirection(): void {
    this.startUpConfigUiService.cmsUrl$.pipe(take(1)).subscribe({
      next: (cmsUrl) => {
        if (cmsUrl) {
          location.href = cmsUrl;
        }
      }
    });
  }
  private processLanding(): void {
    // Ensure Process landing runs only once
    if (this.isProcessingLandingCalled) {
      return;
    }

    this.subscription = this.landingService.processLanding()
      .subscribe({
        next: (data) => {
          if (data && data.isSuccess) {
            this.performRedirection(data.source, data.encryptedId);
          } else {
            this.handleRedirection();
          }
        },
        error: (err) => {
          this.handleRedirection();
        }
      });
    this.isProcessingLandingCalled = true;
  }

  ngOnInit(): void {
    this.gtmDatalayerUIService.initGtmDatalayer(this.startUpConfigUiService.sessionInfo$).subscribe();
    const routerSub = this.router.events.subscribe({
      next: (navigationEvent) => {
        if (navigationEvent instanceof NavigationEnd) {
          if (routerSub) {
            routerSub.unsubscribe();
          }
          this.processLanding();
        }
      }
    });
    const cSig = this.route.snapshot.queryParamMap.get('c-sig');
    if (!cSig) {
      // Redirect to quote landing with the client signature
      this.landingService.getGeneratedSignature().pipe(take(1)).subscribe({
        next: (clientSignature) => {
          this.router.navigate(['/email-landing'], {
            queryParamsHandling: 'merge',
            queryParams: {
              'c-sig': clientSignature
            }
          });
        }
      });
    } else {
      this.processLanding();
    }
  }
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
